export default __webpack_public_path__ + "static/media/phone.dc08eeb7.svg";